import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { LeftControl, RightControl } from './Controls';
import Slider from 'react-slick';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import style from './styles/style.module.css';


class Carousel extends PureComponent {
    constructor(props) {
        super(props);

        this.defaultSettings = {
            lazyLoad: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            swipeToSlide: false,
            prevArrow: <LeftControl style={ this.props.arrowStyle } />,
            nextArrow: <RightControl style={ this.props.arrowStyle } />,
            responsive: [
                {
                    breakpoint:1280,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint:480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
            ],
        };


        var settings = {
            ...this.defaultSettings,
            ...this.props.sliderSettings,
            vertical: !!this.props.vertical,
            verticalSwiping: !!this.props.vertical,
        };
        settings = this.calcSettings( settings );
        this.state = {
            firstCheck: false,
            settings,
        };
    }
    componentDidMount() {
        var settings = {
            ...this.defaultSettings,
            ...this.props.sliderSettings,
            vertical: !!this.props.vertical,
            verticalSwiping: !!this.props.vertical,
        };
        settings = this.calcSettings( settings );
        this.setState( { firstCheck: true, settings } );
    }
    UNSAFE_componentWillReceiveProps( nextProps ) {
        if( ( this.props.screenWidth != nextProps.screenWidth ) ||
        ( this.props.sliderSettings != nextProps.sliderSettings ) ) {
            var settings = {
                ...this.defaultSettings,
                ...this.props.sliderSettings,
                vertical: !!this.props.vertical,
                verticalSwiping: !!this.props.vertical,
            };
            settings = this.calcSettings( settings );
            this.setState( { settings } );
        }
    }
    calcSettings = ( settings ) => {
        settings = { ...settings };
        if( this.el && !!settings.responsive ) {
            var responsive = [ ...settings.responsive ];
            var testWidth = this.el.clientWidth;
            for( var i = 0; i < responsive.length; i++ ) {
                var size = responsive[ i ].breakpoint;
                if( testWidth < size ) {
                    settings = { ...settings, ...responsive[i].settings };
                }
            }
        }
        settings.responsive = null;
        return settings;
    }
    render() {
        return (
            <div style={ this.props.style } className={ `${ style.carouselWrapper } ${ this.props.wrapperClass }` } ref={ ( el ) => { this.el = el; } } >
                { this.props.fetching || !this.state.firstCheck ?
                    <LoadingReplace style={ { justifyContent: 'flex-start' } } />
                    :
                    <div className={ `${ style.carousel } ${ this.props.className }` } data-vertical={ this.props.vertical } style={ this.props.carouselStyle }>
                        <Slider { ...this.state.settings }
                    ref={ ( c ) => { this.slider = c; } }>
                            { this.props.children }
                        </Slider>
                    </div>
                }
            </div>
        );
    }
}
Carousel.defaultProps = {
    className: '',
    wrapperClass: '',
    children: null,
    fetching: false,
    arrowStyle: {},
};


const mapStateToProps = ( state ) => {
    return {
        screenWidth: state.screenSize.width,
    };
};

export default connect( mapStateToProps )( Carousel );
